import React from "react";
import GridContainer from "components/UI/Grid/GridContainer";
import ProcessListCard from "../ProcessListCard";
import {
  ActivityItemStats,
  DashboardWorkItemsStatResponse,
} from "services/input-core/dashboard/dashboard";
import { useNavigate } from "react-router-dom";
import { useSubscription } from "store/auth/auth-store";
import keycloak from "configs/keycloak";

interface ProcessListSection {
  processes: DashboardWorkItemsStatResponse;
  isProcessesLoading: boolean;
  activityItemStats?: Array<ActivityItemStats>;
}

const ProcessListSection: React.FC<ProcessListSection> = ({
  processes,
  isProcessesLoading,
  activityItemStats,
}) => {
  const navigate = useNavigate();
  const { isBeltrame, isAcelen } = useSubscription();

  function formatActivityItems() {
    return activityItemStats?.map((item: ActivityItemStats) => ({
      activityItem: {
        activityItemDescription: item.activityItemDescription,
        _id: item._id,
      },
      activityItemDueDate: item.activityItemDueDate,
      _id: item._id,
      type: item.profile,
      supplier: {
        _id: item._id,
        supplierName: item.supplierName,
        supplierCode: item.supplierCode,
      },
      requestParam: item.fieldglassId,
      profile: item.profile,
      updatedAt: item.updatedAt,
    }));
  }

  return (
    <GridContainer>
      {!isBeltrame && !isAcelen && (
        <ProcessListCard
          xs={12}
          tableSize={{ justify: "space-between", xs: 12, sm: 12, md: 12 }}
          color="success"
          icon="search"
          title="last-approved"
          value={processes?.workItemsLatestApproved}
          isLoading={isProcessesLoading}
          onClick={() => navigate("/app/latestApprovedAnalysis")}
        />
      )}
      {!isBeltrame && !isAcelen && (
        <ProcessListCard
          xs={12}
          tableSize={{ justify: "space-between", xs: 12, sm: 12, md: 12 }}
          color="warning"
          icon="search"
          title="last-pending"
          value={formatActivityItems()}
          isLoading={isProcessesLoading}
          onClick={() => navigate("/app/latestPendingAnalysis")}
        />
      )}
      {!keycloak.hasResourceRole("supplier", "uverify") && !isAcelen && (
        <ProcessListCard
          xs={12}
          tableSize={{ justify: "space-between", xs: 12, sm: 12, md: 12 }}
          color="danger"
          icon="search"
          title="last-rejected"
          value={processes?.workItemsLatestRejected}
          isLoading={isProcessesLoading}
          onClick={() => navigate("/app/latestRejectedAnalysis")}
        />
      )}
    </GridContainer>
  );
};

export default ProcessListSection;
